import { render, staticRenderFns } from "./DisplayResult.vue?vue&type=template&id=565fe69f"
import script from "./DisplayResult.vue?vue&type=script&lang=js"
export * from "./DisplayResult.vue?vue&type=script&lang=js"
import style0 from "./DisplayResult.vue?vue&type=style&index=0&id=565fe69f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports